import React, {useEffect, useState} from "react";
import {getHomeCMSContent,getTop5Posting} from 'api/mainTab'
import { CMS_COMPONENT_MAP } from "components/cms";
import HotPostCarousel from "components/cms/HotPostCarousel";
import "components/cms/cms.scss";
import "assets/scss/pages/HomeContents.scss";

function HomeContents() {
  const [cms , setCms] = useState([]);
  const [top5Posting, setTop5Posting] = useState([])

  useEffect(()=>{
    getHomeCMSContent()
    .then(res => {
      const cmsList = res.results.filter((c) => c.is_active)
      .sort((a, b) => a.order - b.order);
      setCms(cmsList)
    })
    getTop5Posting()
    .then(res => {
      setTop5Posting(res.data)
    })
  },[])

  return (
    <div className="home-contents">
        <main className="home-contents__body">
          {cms.map((section) => {
            const Component = CMS_COMPONENT_MAP[section.component_type];
            if (!Component) return null;
            return (
              <section key={section.id} className="home-contents__section">
                <Component
                  title={section.name}
                  subtitle={section.subTitle}
                  layout={section.layout}
                  items={section.items}
                  categories={section.categories || []}
                />
              </section>
            );
          })}
          
          {/* 커뮤니티 인기 게시글 */}
          {/* <div className="home-contents__section">
            <HotPostCarousel posts={top5Posting} />
          </div> */}
        </main>
    </div>
  );
}

export default HomeContents;
